import { icons, } from '../../constants/images'
import { Box, Grid } from '@mui/material'
import { BoxList, HeadList, ListGrid } from '../../page/documents/documentStyle'
import ListDoc from '../listDoc/listDoc'
type Props = {
    step: any
    viewType: string
    level1: any
    level2: any
    level3: any
    level4: any
    setLevel1: any
    setLevel2: any
    setLevel3: any
    setLevel4: any
    setLevelFiles: any
    setFile: any
    setOpenFile: any
    levelfiles: any
    inputFolder: any
    setInputFolder: any
    handleStepUpdate: any
    loadData: any
    loadDataLevel: any
    handleClickOpenCreate: any
    permit?: any
}
export default function ColumnFolder(props: Props) {
    const {
        step,
        viewType,
        level1,
        level2,
        level3,
        level4,
        setLevel1,
        setLevel2,
        setLevel3,
        setLevel4,
        setLevelFiles,
        setFile,
        setInputFolder,
        setOpenFile,
        levelfiles,
        inputFolder,
        handleStepUpdate,
        loadData,
        loadDataLevel,
        handleClickOpenCreate,
        permit
    } = props
    return (
        <>
            <Box sx={{ width: "100%", overflowX: 'auto' }}>
                <Grid container sx={{
                    borderRight: '1px solid #E5E5E7',
                    borderRadius: '10px',
                    overflow: "hidden",
                    borderBottom: '1px solid #E5E5E7',
                    width: '1428px',
                    // borderLeft: '1px solid',
                    background: '#f3f3f3'
                }}>
                    <ListGrid item xs={2} >
                        <HeadList>
                            ตู้เอกสาร/หน่วยงาน
                        </HeadList>
                        <BoxList>
                            {level1?.map((x: any, i: number) => {
                                return (
                                    <ListDoc
                                        style={{
                                            background: step[0] === x?.idFolder ? '#1c9559' : !x?.isEmpty ? '#fff' : '#e3e3e3',
                                            color: step[0] === x?.idFolder ? '#fff' : '#000',
                                            '& svg': {
                                                color: step[0] === x?.idFolder ? '#fff' : '#000',
                                            },
                                            ':hover': {
                                                background: step[0] === x?.idFolder ? '#24b36c' : '#EFFFF7'
                                            }
                                        }} icon={<icons.Building className='icon-list' />}
                                        onClick={
                                            async () => {
                                                if (step[0] === x?.idFolder) {
                                                    setLevel2(null)
                                                    setLevel3(null)
                                                    setLevel4(null)
                                                    setLevelFiles(null)
                                                    setInputFolder({ ...inputFolder, idReferFolder: null, stepView: 1, permissionLevel: null, permitLevel: permit?.find((x: any) => x?.code === 'Level1.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                                    handleStepUpdate(0, 0)
                                                    handleStepUpdate(0, 1)
                                                    handleStepUpdate(0, 2)
                                                    handleStepUpdate(0, 3)
                                                    handleStepUpdate(0, 4)
                                                } else {
                                                    handleStepUpdate(x.idFolder, 0)
                                                    setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 2, permissionLevel: x?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level2.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })

                                                    setLevel3(null)
                                                    setLevel4(null)
                                                    handleStepUpdate(0, 1)
                                                    handleStepUpdate(0, 2)
                                                    handleStepUpdate(0, 3)
                                                    handleStepUpdate(0, 4)
                                                }

                                            }}
                                        loadDataLevel={loadDataLevel}
                                        setLevel={setLevel1}
                                        handleClickOpenCreate={handleClickOpenCreate}
                                        inputFolder={inputFolder}
                                        setInputFolder={setInputFolder}
                                        detail={x}
                                        stepView={1}
                                        layer={i}
                                        loadData={loadData}
                                        checkbox />
                                )
                            })}
                        </BoxList>

                    </ListGrid>
                    <ListGrid item xs={2} >
                        <HeadList>
                            ชั้นเอกสาร
                        </HeadList>
                        <BoxList>
                            {level2 && level2?.map((x: any, i: number) => {
                                return (
                                    <>{x?.idFolder ?
                                        <ListDoc
                                            style={{
                                                background: step[1] === x?.idFolder ? '#1c9559' : !x?.isEmpty ? '#fff' : '#e3e3e3',
                                                color: step[1] === x?.idFolder ? '#fff' : '#000',
                                                '& svg': {
                                                    color: step[1] === x?.idFolder ? '#fff' : '#000',
                                                },
                                                ':hover': {
                                                    background: step[1] === x?.idFolder ? '#24b36c' : '#EFFFF7'
                                                }
                                            }}
                                            icon={<icons.listFolder className='icon-list' />}
                                            onClick={
                                                async () => {
                                                    if (step[1] === x?.idFolder) {
                                                        setLevel3(null)
                                                        setLevel4(null)
                                                        const data = await loadDataLevel(step[0])
                                                        setInputFolder({ ...inputFolder, idReferFolder: step[0], stepView: 2, permissionLevel: data?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level2.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                                        let newArray = new Array(level1?.indexOf(level1?.find((n: any) => n?.idFolder === step[0])))
                                                        setLevel2([...newArray, ...data?.detailFolders])
                                                        setLevelFiles([...newArray, ...data?.detailFiles])
                                                        handleStepUpdate(0, 1)
                                                        handleStepUpdate(0, 2)
                                                        handleStepUpdate(0, 3)
                                                        handleStepUpdate(0, 4)
                                                    } else {
                                                        handleStepUpdate(x?.idFolder, 1)
                                                        setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 3, permissionLevel: x?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level3.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })

                                                        setLevel4(null)
                                                        handleStepUpdate(0, 2)
                                                        handleStepUpdate(0, 3)
                                                        handleStepUpdate(0, 4)
                                                    }
                                                }}
                                            loadDataLevel={loadDataLevel}
                                            setLevel={setLevel2}
                                            handleClickOpenCreate={handleClickOpenCreate}
                                            inputFolder={inputFolder}
                                            setInputFolder={setInputFolder}
                                            detail={x}
                                            stepView={2}
                                            layer={i}
                                            loadData={loadData}
                                            checkbox
                                            step={step[0]}
                                        />
                                        : <div style={{ padding: "12px", border: '1px solid #f3f3f3', background: '#f3f3f3' }}><icons.listFolder className='icon-list' style={{ opacity: 0 }} /></div>}</>
                                )
                            })}
                        </BoxList>

                    </ListGrid>
                    <ListGrid item xs={2}>
                        <HeadList>
                            แฟ้มเอกสาร
                        </HeadList>
                        <BoxList>
                            {level3 && level3?.map((x: any, i: number) => {
                                return (
                                    <>{x?.idFolder ?
                                        <ListDoc
                                            style={{
                                                background: step[2] === x?.idFolder ? '#1c9559' : !x?.isEmpty ? '#fff' : '#e3e3e3',
                                                color: step[2] === x?.idFolder ? '#fff' : '#000',
                                                '& svg': {
                                                    color: step[2] === x?.idFolder ? '#fff' : '#000',
                                                },
                                                ':hover': {
                                                    background: step[2] === x?.idFolder ? '#24b36c' : '#EFFFF7'
                                                }
                                            }} icon={<icons.Folder className='icon-list' />}
                                            onClick={
                                                async () => {
                                                    if (step[2] === x?.idFolder) {
                                                        setLevel4(null)
                                                        const data = await loadDataLevel(step[1])
                                                        const newArray = new Array(level2?.indexOf(level2?.find((n: any) => n?.idFolder === step[1])))
                                                        setInputFolder({ ...inputFolder, idReferFolder: step[1], stepView: 3, permissionLevel: data?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level3.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                                        setLevel3([...newArray, ...data?.detailFolders])
                                                        setLevelFiles([...newArray, ...data?.detailFiles])
                                                        handleStepUpdate(0, 2)
                                                        handleStepUpdate(0, 3)
                                                        handleStepUpdate(0, 4)
                                                    } else {
                                                        handleStepUpdate(x.idFolder, 2)
                                                        setInputFolder({ ...inputFolder, idReferFolder: x?.idFolder, layer: i, stepView: 4, permissionLevel: x?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level4.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })

                                                        handleStepUpdate(0, 3)
                                                        handleStepUpdate(0, 4)
                                                    }
                                                }}
                                            loadDataLevel={loadDataLevel}
                                            setLevel={setLevel3}
                                            handleClickOpenCreate={handleClickOpenCreate}
                                            inputFolder={inputFolder}
                                            setInputFolder={setInputFolder}
                                            detail={x}
                                            stepView={3}
                                            layer={i}
                                            loadData={loadData}
                                            checkbox
                                            step={step[1]}
                                            />
                                        : <div style={{ padding: "12px", border: '1px solid #f3f3f3', background: '#f3f3f3' }}><icons.listFolder className='icon-list' style={{ opacity: 0 }} /></div>}</>
                                )
                            })}
                        </BoxList>


                    </ListGrid>
                    <ListGrid item xs={2}>
                        <HeadList>
                            ประเภทเอกสาร
                        </HeadList>
                        <BoxList>
                            {level4 && level4?.map((x: any, i: number) => {
                                return (
                                    <>{x?.idFolder ?
                                        <ListDoc
                                            style={{
                                                background: step[3] === x?.idFolder ? '#1c9559' : !x?.isEmpty ? '#fff' : '#e3e3e3',
                                                color: step[3] === x?.idFolder ? '#fff' : '#000',
                                                '& svg': {
                                                    color: step[3] === x?.idFolder ? '#fff' : '#000',
                                                },
                                                ':hover': {
                                                    background: step[3] === x?.idFolder ? '#24b36c' : '#EFFFF7'
                                                }
                                            }} icon={<icons.double className='icon-list' />}
                                            onClick={
                                                async () => {
                                                    if (step[3] === x.idFolder) {
                                                        const data = await loadDataLevel(step[2])
                                                        const newArray = new Array(level3?.indexOf(level3?.find((n: any) => n?.idFolder === step[2])))
                                                        setInputFolder({ ...inputFolder, idReferFolder: step[2], stepView: 4, permissionLevel: data?.permissionLevel, permitLevel: permit?.find((x: any) => x?.code === 'Level4.Add')?.permit, permitUpload: permit?.find((x: any) => x?.code === 'upload.Add')?.permit })
                                                        setLevel4([...newArray, ...data?.detailFolders])
                                                        setLevelFiles([...newArray, ...data?.detailFiles])
                                                        handleStepUpdate(0, 3)
                                                        handleStepUpdate(0, 4)
                                                    } else {
                                                        handleStepUpdate(x?.idFolder, 3)
                                                        setInputFolder({
                                                            ...inputFolder,
                                                            idReferFolder: x?.idFolder,
                                                            layer: i,
                                                            stepView: 5,
                                                            permissionLevel: x?.permissionLevel
                                                        })

                                                        handleStepUpdate(0, 4)
                                                    }
                                                }}
                                            loadDataLevel={loadDataLevel}
                                            setLevel={setLevel4}
                                            handleClickOpenCreate={handleClickOpenCreate}
                                            inputFolder={inputFolder}
                                            setInputFolder={setInputFolder}
                                            detail={x}
                                            stepView={4}
                                            layer={i}
                                            loadData={loadData}
                                            checkbox
                                            step={step[3]}
                                            />
                                        : <div style={{ padding: "12px", border: '1px solid #f3f3f3', background: '#f3f3f3' }}><icons.listFolder className='icon-list' style={{ opacity: 0 }} /></div>}</>

                                )
                            })}
                        </BoxList>
                    </ListGrid>
                    <ListGrid item xs={4}>
                        <HeadList>
                            เอกสาร
                            {/* <icons.upDown /> */}
                        </HeadList>
                        <BoxList>
                            {levelfiles && levelfiles?.filter((x: any) => x?.fileStatus !== 'ไม่ใช้งาน')?.map((x: any, i: number) => {
                                return (
                                    <>{x?.idFolder ?
                                        <ListDoc
                                            file={x} type={'file'} style={{ background: '#fff' }} icon={<icons.file className='icon-list' />}
                                            onClick={() => {
                                                setFile(x)
                                                setOpenFile(true)
                                            }}
                                            detail={x}
                                            levelfiles={levelfiles}
                                            setLevelFiles={setLevelFiles}
                                            loadData={loadData}
                                            layer={i}
                                            stepView={5}
                                        />
                                        : <div style={{ padding: "12px", border: '1px solid #f3f3f3', background: '#f3f3f3' }}><icons.listFolder className='icon-list' style={{ opacity: 0 }} /></div>}</>

                                )
                            })}
                        </BoxList>
                    </ListGrid>
                </Grid>
            </Box>
        </>
    )
}
